import React from 'react';
import { CordexaCoreLoader } from './CordexaCoreLoader';
import styles from './CordexaLoader.module.css';
import type { CordexaCoreVariant, CordexaLoaderSize, CordexaLoaderVariant } from './types';

export type CordexaLoaderProps = {
  variant?: CordexaLoaderVariant;
  coreVariant?: CordexaCoreVariant;
  size?: CordexaLoaderSize;
  calm?: boolean;
  label?: string;
  srLabel: string;
  className?: string;
  'data-testid'?: string;
};

const dotsClass: Record<CordexaLoaderSize, string> = {
  sm: styles.dotsSm,
  md: styles.dotsMd,
  lg: styles.dotsLg,
};

function resolveCoreVariant(
  variant: CordexaLoaderVariant,
  coreVariant: CordexaCoreVariant | undefined,
): CordexaCoreVariant {
  if (coreVariant) {
    return coreVariant;
  }
  if (variant === 'orb') {
    return 'app';
  }
  return 'region';
}

function isCoreVariant(variant: CordexaLoaderVariant): boolean {
  return variant === 'orb' || variant === 'core';
}

export function CordexaLoader({
  variant = 'dots',
  coreVariant,
  size,
  calm,
  label,
  srLabel,
  className,
  'data-testid': dataTestId,
}: CordexaLoaderProps) {
  const usesCore = isCoreVariant(variant);
  const testId =
    dataTestId ??
    (usesCore ? 'cordexa-loader-core' : 'cordexa-loader-dots');

  return (
    <div
      className={[styles.root, styles.reducedMotionStatic, className].filter(Boolean).join(' ')}
      role="status"
      aria-live="polite"
      data-testid={testId}
    >
      <span className={styles.srOnly}>{srLabel}</span>
      {usesCore ? (
        <CordexaCoreLoader
          variant={resolveCoreVariant(variant, coreVariant)}
          calm={calm}
        />
      ) : (
        <span className={[styles.dots, dotsClass[size ?? 'md']].join(' ')} aria-hidden="true">
          <span />
          <span />
          <span />
        </span>
      )}
    </div>
  );
}
